import React from 'react';

const Footer: React.FC = () => {
  return (
    // <footer className="border-t border-gray-600 py-8 mt-16">
    <footer className="py-8 mt-16">
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-8">
          <a
            href="https://github.com/tgben"
            target="_blank"
            rel="noopener noreferrer"
            className="text-text-gray hover:text-primary transition-colors text-center hover:drop-shadow-glow"
          >
            github/tgben
          </a>
          <a
            href="mailto:thomasgeorgebenoit@gmail.com"
            className="text-text-gray hover:text-primary transition-colors text-center hover:drop-shadow-glow"
          >
            thomasgeorgebenoit@gmail.com
          </a>
          <a
            href="https://linkedin.com/in/tgbenoit"
            target="_blank"
            rel="noopener noreferrer"
            className="text-text-gray hover:text-primary transition-colors text-center hover:drop-shadow-glow"
          >
            linkedin/tgbenoit
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;